import { AfterContentInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScrollModeType } from 'ngx-extended-pdf-viewer';
import { Alumnos } from 'src/app/interface/alumnos';
import { personasMap } from 'src/utils/models/alumnos';

@Component({
  selector: 'app-segem-certificacion',
  templateUrl: './segem-certificacion.component.html',
  styleUrls: ['./segem-certificacion.component.css']
})
export class SegemCertificacionComponent implements OnInit, AfterContentInit {
  dimensionW: number;
  pdfSource: string;
  uuid: string | null;
  _color: string = 'white';
  alumno: Alumnos;
  scrollType: ScrollModeType = ScrollModeType.vertical;

  // Estado de error para mostrar mensajes en la vista
  errorMessage: string | null = null;

  constructor(private route: ActivatedRoute) {
    this.uuid = '';
    this.pdfSource = '';
    this.dimensionW = screen.width;
    this.alumno = { id: '', nombre: '', archivo: '' };
  }

  ngOnInit(): void {
    try {
      this.uuid = this.route.snapshot.queryParamMap.get('uuid');

      if (!this.uuid) {
        this.errorMessage = 'No se proporcionó un identificador válido en la URL.';
        return;
      }

      const alumno = personasMap.get(this.uuid);

      if (!alumno) {
        this.errorMessage = `No se encontró un alumno : ${this.uuid}`;
        return;
      }

      let { archivo } = alumno;

      // Normalizamos extensión PDF
      if (!archivo.toLowerCase().endsWith('.pdf')) {
        archivo += '.pdf';
      }

      this.pdfSource = `/assets/${archivo}`;
      this.alumno = alumno;

    } catch (error) {
      console.error('Error al inicializar el componente:', error);
      this.errorMessage = 'Ocurrió un error inesperado al cargar la certificación.';
    }
  }

  ngAfterContentInit(): void {
    // Aquí podrías agregar lógica adicional si necesitas ajustar el viewer
  }

  // Método para manejar errores al cargar el PDF
  onPdfError(event: any): void {
    console.error('Error al cargar el PDF:', event);
    this.errorMessage = 'No se pudo cargar el archivo PDF. Verifica que exista en la carpeta assets.';
    this.pdfSource = ''; // Limpiamos la fuente para evitar intentos fallidos
  }
}

// ngAfterContentInit(): void {
//   // setTimeout(() => {
//   //   let canvas = document.getElementsByTagName('canvas')[0]
//   //   console.log(canvas)
//   //   canvas.style.setProperty('font-size','28px !important')
//   //   let ctrx = canvas.getContext('2d')
//   //   if(ctrx != undefined){
//   //     console.log('entra')
      
//   //   }
//   // console.log()
//   // }, 2000);
// }